import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import CityAreaFilter from '@components/cityAreaFilter/CityAreaFilter';

import FilterGroup from '../FilterGroup';

const AreaFilters = ({ cityAreas, onChange, cityAreaIds }) => (
  <FilterGroup classModifier="checkboxes" label={trans('search.filter.area')}>
    <CityAreaFilter
      prefix="search_filters"
      cityAreas={cityAreas}
      onChange={onChange}
      cityAreaIds={cityAreaIds}
    />
  </FilterGroup>
);

AreaFilters.propTypes = {
  cityAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }).isRequired
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  cityAreaIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default AreaFilters;
